import { useTranslation } from 'react-i18next';

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Spinner } from '@/components/ui/spinner';

interface DisconnectMailboxDialogProps {
  email: string;
  isPending: boolean;
  onConfirm: () => void;
  onOpenChange: (open: boolean) => void;
  open: boolean;
}

// Pure presentational confirm dialog; cognitive score is JSX nesting, not logic.
// fallow-ignore-next-line complexity
export function DisconnectMailboxDialog({
  email,
  isPending,
  onConfirm,
  onOpenChange,
  open,
}: DisconnectMailboxDialogProps) {
  const { t } = useTranslation();

  return (
    <AlertDialog onOpenChange={onOpenChange} open={open}>
      <AlertDialogContent className="max-w-[calc(100%-2rem)] gap-2.5 p-3">
        <AlertDialogHeader className="gap-0.5">
          <AlertDialogTitle className="text-left font-['Inter'] text-[13px] leading-[170%] font-medium text-[#333333]">
            {t('profile.mailbox.dialog.title')}
          </AlertDialogTitle>
          <AlertDialogDescription className="mt-0.5 text-left font-['Inter'] text-[12px] leading-[160%] font-normal text-[#595959]">
            {t('profile.mailbox.dialog.description', { email })}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="mt-1.5 flex-row justify-end gap-1.5">
          <AlertDialogCancel
            className="m-0 h-7 rounded-md border border-[#333333] bg-white px-2.5 py-1.5 text-xs text-[#333333] hover:bg-gray-50"
            disabled={isPending}
            onClick={() => onOpenChange(false)}
            size="sm"
            variant="outline"
          >
            {t('profile.mailbox.dialog.cancel')}
          </AlertDialogCancel>
          <AlertDialogAction
            className="m-0 inline-flex h-7 items-center gap-1.5 rounded-md bg-black px-2.5 py-1.5 text-xs text-white hover:bg-black hover:opacity-90"
            disabled={isPending}
            onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
              event.preventDefault();
              onConfirm();
            }}
          >
            {isPending && <Spinner className="size-3 text-white" />}
            {isPending
              ? t('profile.mailbox.dialog.disconnecting')
              : t('profile.mailbox.dialog.confirm')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
